/**
 * Session key for modal/page form hydration — hydrate only when session changes,
 * not on parent re-render or RTK refetch with the same entity.
 */
export function buildFormHydrationSessionKey(params: {
  isOpen: boolean;
  editEntityId?: number | null;
  createExtraKey?: string;
}): string | null {
  if (!params.isOpen) return null;
  if (params.editEntityId != null) return `edit-${params.editEntityId}`;
  return `create-${params.createExtraKey ?? ''}`;
}

export function shouldHydrateFormSession(
  previousSessionKey: string | null,
  nextSessionKey: string | null
): boolean {
  if (nextSessionKey == null) return false;
  return previousSessionKey !== nextSessionKey;
}

export function defaultRolesStableKey(roles: readonly string[]): string {
  return roles.length === 0 ? '_none' : roles.join(',');
}
